import {
  InquiryUnrespondedMessagesActionTypes,
  RECIEVED_INQUIRY_LIST,
  RECIEVED_UNRESPONDED_MESSAGE_COUNT,
} from '../actions/types/InquiryActionTypes';

export type InquiryState = {
  unreadTotal: number;
  hasInquiries: boolean;
};

export const initialState: InquiryState = {
  unreadTotal: 0,
  hasInquiries: false,
};

const inquiryReducer = (
  state: InquiryState = initialState,
  action: InquiryUnrespondedMessagesActionTypes
): InquiryState => {
  switch (action.type) {
    case RECIEVED_UNRESPONDED_MESSAGE_COUNT: {
      const unreadTotal = action.payload;
      return { ...state, unreadTotal };
    }
    case RECIEVED_INQUIRY_LIST: {
      const inquiryList = action.payload.inquiries;
      const hasInquiries = inquiryList.length > 0;
      return { ...state, hasInquiries };
    }
    default:
      return state;
  }
};

export default inquiryReducer;
